<template>
  <div>
    <div class="container-alb filter-mobile">
      <table
        cellpadding="10"
        cellspacing="0"
        width="95%"
        class="hover-table"
        align="center"
      >
        <tr>
          <td>
            {{ $t("keyLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="text"
                class="formedituser"
                v-model="filters.key"
                v-on:keyup.enter="searchComplaints()"
              />
            </form>
          </td>
          <td>
            {{ $t("beneficiariesTableCNP") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="text"
                class="formedituser"
                v-model="filters.cnp"
                v-on:keyup.enter="searchComplaints()"
              />
            </form>
          </td>
          <td>
            {{ $t("cardidLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="text"
                class="formedituser"
                v-model="filters.cardId"
                v-on:keyup.enter="searchComplaints()"
              />
            </form>
          </td>
           <td>
            {{ $t("codallLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="text"
                class="formedituser"
                v-model="filters.codhd"
                v-on:keyup.enter="searchComplaints()"
              />
            </form>
          </td>
        </tr>
        <tr>
          <td>
            {{ $t("titleLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
            <select class="filtrare" @change="titleSelected">
              <option value="" :selected= " ''=== filters.title">                {{ $t('cardsAction_CHOOSE') }}              </option>
              <option v-for="(entry, index) in complaintTitles" :key="index" :value="entry.id"
                :selected="entry.id  === filters.title">
                {{ entry.name }}
              </option>
            </select>
              <!-- <input
                type="text"
                class="formedituser"
                v-model="filters.status"
                v-on:keyup.enter="searchComplaints()"
              /> -->
            </form>
          </td>
          <td>
            {{ $t("statusLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
            <select class="filtrare" @change="statusSelected">
              <option value="" :selected= " ''=== filters.status">                {{ $t('cardsAction_CHOOSE') }}              </option>
              <option v-for="(entry, index) in complaintStatuses" :key="index" :value="entry.id"
                :selected="entry.id  === filters.status">
                {{ entry.name }}
              </option>
            </select>
              <!-- <input
                type="text"
                class="formedituser"
                v-model="filters.status"
                v-on:keyup.enter="searchComplaints()"
              /> -->
            </form>
          </td>
          <td>
            {{ $t("userLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
            <select class="filtrare" @change="userSelected">
              <option value="" :selected="'' === filters.status">                {{ $t('cardsAction_CHOOSE') }}              </option>
              <option v-for="(entry, index) in complaintUsers" :key="index" :value="entry.id"
                :selected="entry.id === filters.user">
                {{ entry.username }}
              </option>
            </select>
              <!-- <input
                type="text"
                class="formedituser"
                v-model="filters.user"
                v-on:keyup.enter="searchComplaints()"
              /> -->
            </form>
          </td>
        </tr>
      </table>
    </div>

    <!-- card transaction -->
    <div class="container-alb">
      <!-- <div class="table-header-wrapper">
        <div class="left">
          <h3 class="table-title d-inline-block">
            {{ $t("beneficiariesName") }}
          </h3>
           <img
            class="download d-inline-block"
            @click="getExcelTransaction()"
            src="@/assets/images/download.svg"
          /> --
        </div>
      </div> -->
      <br />

      <ComplaintsTable
        :complaints="this.complaintsList"
        @change="sortBy(sortField, sortDirection)"
      />

      <div
        class="error-wrapper border-box"
        v-if="this.complaintsList && this.complaintsList.length === 0"
      >
        <p>{{ $t("noBeneficiariesInfoMessage") }}</p>
      </div>

      <div class="error-wrapper border-box" v-if="this.transactionError">
        <p>{{ $t("errorTransactionMessage") }}</p>
      </div>

      <div class="pagination-wrapper border-box">
        <b-pagination
          v-model="currentPage"
          :total-rows="this.complaintsCount"
          :per-page="perPage"
          size="sm"
        ></b-pagination>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <p v-html="$t('errorActionBeneficiary_' + this.error.code)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ComplaintsTable from "@/components/company/beneficiaries-support/ComplaintsTable.vue";

  import httpServiceBenef from "@/http/http-ben-support.js";
  import { BPagination } from "bootstrap-vue";
  import Cookies from "js-cookie";

  export default {
    props: {
      msg: String,
    },
    components: {
      ComplaintsTable,
      "b-pagination": BPagination,
      // Multiselect
    },
    data() {
      return {
        transactionError: null,
        complaintsList: [],
        tempInvoices: null,
        filters: {
          cnp: "",
          cardId: "",
          status: 1,
          title: "",
          user: "",
          codhd: "",
          key: ""

        },
        // Status, Tip reclamatie si User
        complaintDetais: null,
        complaintStatuses: null,
        complaintTitles: null,
        complaintUsers: null,
        complaintsCount: 10,
        perPage: 30,
        currentPage: 1,
        sortField: "date",
        sortDirection: "desc",
        selectedProduct: null,
        error: null,
        config: JSON.parse(sessionStorage.getItem("client_jsonFile")),
      };
    },
    methods: {
      statusSelected(event) {
        this.filters.status = event.target.value;
        this.searchComplaints();
      },
      titleSelected(event) {
        this.filters.title = event.target.value;
        this.searchComplaints();
      },
      userSelected(event) {
        this.filters.user = event.target.value;
        this.searchComplaints();
      },
      isSelectedProduct(product) {
        return product === this.filters.product;
      },
      sortBy(sortField, sortDirection, status) {
        this.sortField = sortField;
        this.sortDirection = sortDirection;
        this.searchComplaints(status);
      },
      showModalPopup(elementId, show) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      searchComplaints() {
        this.error = null;
        if (this.filters.cnp != null && this.filters.cnp.length > 0 && this.filters.cnp.length !== 13) {
          this.error = { code: "CNP_INVALID" };
        }
        if (this.error != null) {
          this.showModalPopup("modal_popup_info", true);
          return;
        }
        // this.complaintsList = [{
        //   cnp: '2881201465588',
        //   email: 'acioc@upromania.ro',
        //   phone: '0547896554',
        //   user: 'Andreea',
        //   title: 'Cioc',
        //   id: 2345
        // }];
        // this.complaintsCount = 10;
        // return;
        var complaintsFilter = {
          per_page: this.perPage,
          page: this.currentPage,
          // sort: this.sortDirection
        }
        // "?product=" +
        // this.filters.product +
        if (this.filters.cnp.trim().length > 0) {
          complaintsFilter.cnp = this.filters.cnp;
        }
        if (this.filters.cardId.trim().length > 0) {
          complaintsFilter.card_id = Number(this.filters.cardId);
        }
        if (this.filters.codhd.trim().length > 0) {
          complaintsFilter.codhd = Number(this.filters.codhd);
        }        
        if (this.filters.key.trim().length > 0) {
          complaintsFilter.key = this.filters.key.trim().toUpperCase();
        }
        if (Number(this.filters.status) > 0) {
          complaintsFilter.status_id = Number(this.filters.status);
        }
        if (this.filters.user.trim().length > 0) {
          complaintsFilter.user_id = Number(this.filters.user);
        }
        if (this.filters.title.trim().length > 0) {
          complaintsFilter.title_id = this.filters.title;
        }
        // (this.filters.username.trim().length > 0
        //   ? "&username=" + this.filters.username
        //   : "") +
        // if (this.sortDirection === "desc") {
        //   complaintsFilter.desc = [this.sortField];
        // } else {
        //   complaintsFilter.asc = [this.sortField];
        // }
        this.showModalPopup("modal_popup_loading", true);

        httpServiceBenef.beneficiariesService
          .searchComplaints(complaintsFilter, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.complaintsList = response.data;
              this.complaintsCount = response.headers["x-up-count"];
            } else if (response.status == 400) {
              this.error = { code: response.data.error_code };
            } else {
              this.error = { code: response.error_code };
            }
            if (this.error) {

              this.showModalPopup("modal_popup_info", true);
            }
            this.showModalPopup("modal_popup_loading", false);
          })

      },
      
      loadComplaintStatuses() {
        httpServiceBenef.beneficiariesService
          .getComplaintStatuses(Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.complaintStatuses = response.data;
            } else {
              this.error = { code: response.error_code };
            }
          })
      },
      loadComplaintUsers() {
        httpServiceBenef.beneficiariesService
          .getComplaintUsers(Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.complaintUsers = response.data;
            } else {
              this.error = { code: response.error_code };
            }
          })
      },
      loadComplaintTitles() {
        httpServiceBenef.beneficiariesService
          .getComplaintTitles(Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.complaintTitles = response.data;
            } else {
              this.error = { code: response.error_code };
            }
          })
      },
    },
    // computed: {
    //   cardProducts() {
    //     let cardProducts = [];
    //     for (let index in this.config.products) {
    //       if (this.config.products[index].card > 0) {
    //         cardProducts.push(this.config.products[index]);
    //       }
    //     }
    //     return cardProducts;
    //   },
    // },
    mounted() {
      Cookies.remove("selectedBeneficiary");
      this.loadComplaintStatuses();
      this.loadComplaintUsers();
      this.loadComplaintTitles();
      this.searchComplaints();
      // this.filters.product = this.config.products[0].card;
      // this.complaintsList = this.searchComplaints();
    },
    created() {
    },
    watch: {
      currentPage: function () {
        this.searchComplaints();
      },
    },
  };
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
  .page-link {
    color: #4a4a4a;
  }

  .page-link:hover {
    color: #4e5b59;
  }

  .page-item.active .page-link {
    background-color: #4e5b59 !important;
    border-color: #4e5b59 !important;
  }

  .invoices-filter .reportrange-text {
    height: 27px;
    font-size: 13px;
    padding: 3px 10px;
    border: none !important;
    color: #585858;
    background: #f1f1f1;
  }
</style>
